import { Grid } from '@mui/material'
import {
  SimpleForm,
  required,
  BooleanInput,
  NumberInput,
  minValue,
  useRecordContext,
  useNotify,
  useRedirect,
  useUpdate,
  Confirm,
  Loading,
} from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { EditBase } from '../../components/base'
import { BranchSelectInput, } from '../../components/form'
import { ServiceMultiSelectInput } from '../../components/form/ServiceMultiSelectInput'
import OverrideConfigCalendar from './OverrideConfigCalendar'
import { TimeStepInput } from '../../components/domains/branch-config/TimeStepInput'
import CustomBranchConfigToolbarWithPermission from '../../components/domains/branch-config/CustomBranchServiceTollbar'
import { closeTime, openTime, validateOpenSlot } from '../../utils/validators'
import { branchConfigTimeConverter } from '../../utils/times'
import _ from 'lodash'
import { useCallback, useState } from 'react'
import { BranchConfig } from './type'

const PREFIX = 'resources.branchconfig.fields'

const EditForm = (): JSX.Element => {
  const [updateData, setUpdateData] = useState({} as BranchConfig)
  const record = useRecordContext()
  const notify = useNotify()
  const [open, setOpen] = useState(false)
  const redirect = useRedirect()
  const handleDialogClose = (): void => setOpen(false)
  // const translate = useTranslate()

  const onError = useCallback(
    (error): void => {
      const errorMessage = error.response.data.message
      return notify(errorMessage || 'ra.validation.update_branch_config_fail', { type: 'error' })
    },
    [notify],
  )

  const onSuccess = useCallback(async (): Promise<void> => {
    notify('ra.notification.update_branch_config_success', { type: 'success' })
    redirect('/branch_config')
  }, [notify, redirect])

  const [update, { isLoading }] = useUpdate(undefined, undefined, { onError, onSuccess })

  const handleSubmit = (data): void => {
    const { ...branch } = data
    setUpdateData(branch as BranchConfig)
    setOpen(true)
  }

  const handleConfirm = useCallback(async (): Promise<void> => {
    const { open_time: o, close_time: c, ...data } = updateData
    const check = {
      ...data,
      open_time: _.isNumber(o) ? branchConfigTimeConverter(o).format('HH:mm') : o,
      close_time: _.isNumber(c) ? branchConfigTimeConverter(c).format('HH:mm') : c,
    }
    await update('branch_config', {
      id: record.id,
      data: check,
    })
    handleDialogClose()
  }, [update, updateData, record])
  if (record === undefined) {
    return <Loading></Loading>
  }
  return (
    <SimpleForm onSubmit={handleSubmit} toolbar={<CustomBranchConfigToolbarWithPermission />}>
      <Confirm
        isOpen={open}
        loading={isLoading}
        title='อัพเดทการจัดการสาขา'
        content='ต้องการเปลี่ยนแปลงการจัดการสาขาใช่หรือไม่?'
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
      <Grid container spacing={1} justifyContent='center'>
        <Grid container item spacing={3} xs={12} md={8}>
          <Grid item xs={12} md={6}>
            <NumberInput
              source='slot'
              label={`${PREFIX}.slot`}
              validate={[required(), minValue(1)]}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <NumberInput
              source='open_slot'
              label={`${PREFIX}.open_slot`}
              validate={[required(), minValue(1), validateOpenSlot]}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TimeStepInput source='open_time' validate={[required(), openTime]} />
          </Grid>
          <Grid item xs={12}>
            <TimeStepInput source='close_time' validate={[required(), closeTime]} />
          </Grid>
          <Grid item xs={12}>
            <BranchSelectInput source='branch_code' validate={[required()]} disabled />
          </Grid>
          <Grid item xs={12}>
            <ServiceMultiSelectInput source='service_key' validate={[required()]} />
          </Grid>
          <Grid item>
            <BooleanInput
              color='primary'
              source='is_active'
              label={`${COMMON_FIELDS}.status.label`}
            />
          </Grid>
        </Grid>
        <Grid container item xs={12} sm={10} md={9} sx={{ pt: 3 }}>
          <Grid item xs={12}>
            <OverrideConfigCalendar />
          </Grid>
        </Grid>
      </Grid>
    </SimpleForm>
  )
}

const branchConfigEdit = (): JSX.Element => {
  return (
    <EditBase
      title={'resources.branchconfig.edit.title'}
      // encType='application/json'
      redirect='list'
      listAction={{
        hasShow: false,
        hasBackButton: true,
      }}
    >
      <EditForm />
    </EditBase>
  )
}

export default branchConfigEdit
